import angular from "angular";

const bulk = require('bulk-require');
const servicesModule = angular.module('app.services', []);
const services = bulk(__dirname, [ './**/!(*index|*.spec).js' ]);

function declare(serviceMap) {
  Object.keys(serviceMap).forEach((key) => {
    let item = serviceMap[ key ].default;

    if (!item) {
      return;
    }

    servicesModule.service(item.name, item.fn);
  });
}

declare(services);

export default servicesModule;
